const featurePrefix = '[LIF][My Favorites]'

export const LOG_ERROR_MESSAGE = {
  CHECK: `${featurePrefix}[Check favorite]`,
  ADD: `${featurePrefix}[Create favorite]`,
  REMOVE: `${featurePrefix}[Remove favorite]`,
  NOTIFICATION: `${featurePrefix}[Notification toast]`,
  FETCH: `${featurePrefix}[Fetch favorites]`,
  ADD_TO_CART: `${featurePrefix}[Add favorite to cart]`,
}
